import { DialerScheduleSettingsService } from '@/services';
import type { DialerScheduleConfig_Input as DialerScheduleConfig } from '@/services';

export type { DialerScheduleConfig };
export type { DayOfWeek } from '@/services';
export type { BlockedWindow } from '@/services';
export type { DialerScheduleTemplate } from '@/services';
export type { Candidate as CallWindow } from '@/services';
export type { Rule_Input as DialerRule } from '@/services';
export type {
  CallNoAnswerFallback,
  CallVolumePeriod,
  ScheduleExhaustedAction,
} from '@/services';
export type { DialerScheduleSettingsResponse as DialerScheduleSettingsVersion } from '@/services';

export const getDialerScheduleSettingsList = (campaignId: string) => {
  return DialerScheduleSettingsService.listDialerScheduleVersionsApiCampaignsCampaignIdDialerScheduleSettingsGet(
    campaignId
  );
};

export const getDialerScheduleSettingsActive = (campaignId: string) => {
  return DialerScheduleSettingsService.getActiveDialerScheduleApiCampaignsCampaignIdDialerScheduleSettingsActiveGet(
    campaignId
  );
};

export const getDialerScheduleSettingsTemplates = (campaignId: string) => {
  return DialerScheduleSettingsService.listDialerScheduleTemplatesApiCampaignsCampaignIdDialerScheduleSettingsTemplatesGet(
    campaignId
  );
};

export const createDialerScheduleSettings = (
  campaignId: string,
  config: DialerScheduleConfig
) => {
  return DialerScheduleSettingsService.createDialerScheduleVersionApiCampaignsCampaignIdDialerScheduleSettingsPost(
    campaignId,
    { config }
  );
};

export const updateDialerScheduleSettings = (
  campaignId: string,
  config: DialerScheduleConfig
) => {
  return DialerScheduleSettingsService.updateActiveDialerScheduleApiCampaignsCampaignIdDialerScheduleSettingsPut(
    campaignId,
    { config }
  );
};

export const activateDialerScheduleSettings = (
  campaignId: string,
  version: number
) => {
  return DialerScheduleSettingsService.activateDialerScheduleVersionApiCampaignsCampaignIdDialerScheduleSettingsVersionActivatePost(
    campaignId,
    version
  );
};
